//This is sloppy, but these are placeholder avatars from the old site to show proof-of-concept for now.

const Avatars = [
  { id: '1', file: '/images/Avatars/avatar_1.svg' },
  { id: '2', file: '/images/Avatars/avatar_2.svg' },
  { id: '3', file: '/images/Avatars/avatar_3.svg' },
  { id: '4', file: '/images/Avatars/avatar_4.svg' },
  { id: '5', file: '/images/Avatars/avatar_5.svg' },
  { id: '6', file: '/images/Avatars/avatar_6.svg' },
  { id: '7', file: '/images/Avatars/avatar_7.svg' },
  { id: '8', file: '/images/Avatars/avatar_8.svg' },
  { id: '9', file: '/images/Avatars/avatar_9.svg' },
  { id: '10', file: '/images/Avatars/avatar_10.svg' },
  { id: '11', file: '/images/Avatars/avatar_11.svg' },
  { id: '12', file: '/images/Avatars/avatar_12.svg' },
]

export default Avatars
